/**
 * SamCart Core
 *
 * Copyright (C) 2014-2016 SamCart, LLC. All Rights Reserved.
 * This software may not be redistributed in any form.
 *
 */

var stripeBillingValidation;
(function(){

    "use strict";

    stripeBillingValidation = {


        init : function() {
            var _this = this;

            this.setElements();

            this.cc_num.payment('formatCardNumber');
            this.cc_exp.payment('formatCardExpiry');
            this.cc_cvc.payment('formatCardCVC');



            this.cc_num.keyup(function(){
                _this.type = $.payment.cardType($(this).val());
                if (_this.type !== null) {
                    _this.greyCC();
                    _this.highlight(_this.type);
                } else {
                    _this.clearCC();
                }
            });

            this.cc_exp.keydown(function(e){
                var code = (e.keyCode ? e.keyCode : e.which);
                if ($(this).val().length === 7 && (code !== 8 && code !== 9 && code !== 46 && code !== 37 && code !== 38 && code !== 39 && code !== 40)) {
                    e.preventDefault();
                }
            });



            this.cc_num.on('blur', function() {
                _this.validateCC();
            });

            this.cc_exp.on('blur', function() {
                _this.validateExp();
            });

            this.cc_cvc.on('blur', function() {
                _this.validateCVC();
            });
        },

        setElements : function() {
            this.cc_num = $('#ccnum');
            this.cc_exp = $('#expyear');
            this.cc_cvc = $('#CVV2');
        },


        clearCC : function() {
            $('.cards .mastercard use').attr('xlink:href', '#mastercard');
            $('.cards .visa use').attr('xlink:href', '#visa');
            $('.cards .discover use').attr('xlink:href', '#discover');
            $('.cards .amex use').attr('xlink:href', '#amex');
            $('.cards .dinersclub use').attr('xlink:href', '#dinersclub');
            $('.cards .jcb use').attr('xlink:href', '#jcb');
        },

        greyCC : function() {
            $('.cards .mastercard use').attr('xlink:href', '#mastercard-gs');
            $('.cards .visa use').attr('xlink:href', '#visa-gs');
            $('.cards .discover use').attr('xlink:href', '#discover-gs');
            $('.cards .amex use').attr('xlink:href', '#amex-gs');
            $('.cards .dinersclub use').attr('xlink:href', '#dinersclub-gs');
            $('.cards .jcb use').attr('xlink:href', '#jcb-gs');
        },

        highlight : function(card) {
            $('.cards .' + card + ' use').attr('xlink:href', '#' + card);
        },

        validate : function() {

            var cc_error = $('#ccnum-error');
            var exp_error = $('#expyear-error');
            var cvc_error = $('#CVV2-error');

            if (!this.validateCC()) {
                cc_error.html('The card number is invalid.');
                return false;
            }

            if (!this.validateExp()) {
                exp_error.html('The expiration date is invalid.');
                return false;
            }

            if (!this.validateCVC()) {
                cvc_error.html('The CVC you entered is invalid.');
                return false;
            }
            return true;
        },

        validateEmail : function(email) {
            return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email);
        },

        validateCC : function() {
            var cc_num = this.cc_num.val();
            if (cc_num === '') {
                //do the error stuff for checkout
                return false;
            }
            this.cc_num.removeClass('empty');
            var valid = $.payment.validateCardNumber(cc_num);
            if (!valid) {
                this.cc_num.addClass('invalid');
                this.cc_num.removeClass('valid');
                return false;
            }
            this.cc_num.removeClass('invalid');
            this.cc_num.addClass('valid');
            return true;
        },

        validateExp : function() {
            var exp = this.cc_exp.val();
            if (exp === '') {
                this.cc_exp.removeClass('valid');
                this.cc_exp.addClass('invalid');
                return false;
            }
            this.cc_exp.removeClass('empty');
            exp = this.parseExp(exp);
            var valid = $.payment.validateCardExpiry(exp.month, exp.year);
            if (!valid) {
                this.cc_exp.addClass('invalid');
                this.cc_exp.removeClass('valid');
                return false;
            }
            this.cc_exp.removeClass('invalid');
            this.cc_exp.addClass('valid');
            return true;
        },

        validateCVC : function() {
            var cvc = this.cc_cvc.val();
            if (cvc === '') {
                this.cc_cvc.removeClass('valid');
                this.cc_cvc.addClass('invalid');
                return false;
            }
            this.cc_cvc.removeClass('empty');
            var card_type = $.payment.cardType(this.cc_num.val());
            var valid = false;
            if (card_type !== null) {
                valid = $.payment.validateCardCVC(cvc, card_type);
            } else {
                valid = $.payment.validateCardCVC(cvc);
            }
            if (!valid) {
                this.cc_cvc.addClass('invalid');
                this.cc_cvc.removeClass('valid');
                return false;
            }
            this.cc_cvc.removeClass('invalid');
            this.cc_cvc.addClass('valid');
            return true;
        },

        parseExp : function(exp) {
            var date = exp.split(' / ');
            return {
                month : date[0],
                year : date[1]
            };
        },


        clear : function() {
            this.inputs.removeClass('invalid');
            this.inputs.removeClass('empty');
            this.inputs.removeClass('valid');
            this.error.html('');
        }

    };

    $(document).ready(function(){

        stripeBillingValidation.init();

    });

})();



$.fn.selectRange = function(start, end) {
    if(end === undefined) {
        end = start;
    }
    return this.each(function() {
        if('selectionStart' in this) {
            this.selectionStart = start;
            this.selectionEnd = end;
        } else if(this.setSelectionRange) {
            this.setSelectionRange(start, end);
        } else if(this.createTextRange) {
            var range = this.createTextRange();
            range.collapse(true);
            range.moveEnd('character', end);
            range.moveStart('character', start);
            range.select();
        }
    });
};